module.exports = __webpack_public_path__ + "static/media/vf_wearring_core.95d73431.svg";